<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        class="fill-current"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12.432 18.7323L8.43137 18.6591C7.13605 18.6336 5.8375 18.6845 4.56758 18.4201C2.63574 18.0252 2.49888 16.0885 2.35567 14.464C2.15834 12.1802 2.23474 9.85488 2.60712 7.5901C2.81734 6.31933 3.64464 5.56105 4.92404 5.47853C9.24295 5.17907 13.5906 5.21456 17.8999 5.35427C18.355 5.36708 18.8133 5.43708 19.262 5.51676C21.4773 5.90538 21.5313 8.10006 21.6749 9.94756C21.8181 11.8141 21.7576 13.6903 21.4839 15.5441C21.2643 17.0791 20.8442 18.3663 19.0711 18.4905C16.8495 18.653 14.6789 18.7838 12.4511 18.7422C12.4512 18.7323 12.4384 18.7323 12.432 18.7323ZM10.08 14.8463C11.7542 13.8842 13.3964 12.9383 15.0609 11.9827C13.3837 11.0206 11.7446 10.0747 10.08 9.11908V14.8463Z"
        />
    </svg>
</template>
